import { useTranslation } from 'react-i18next';

interface RoleSelectorProps {
  id?: string;
  value: string;
  onChange: (role: 'admin' | 'manager' | 'employee' | 'customer') => void;
  disabled?: boolean;
}

export function RoleSelector({ id = 'role-selector', value, onChange, disabled }: RoleSelectorProps) {
  const { t } = useTranslation();

  return (
    <select
      id={id}
      data-testid="role-selector"
      value={value}
      onChange={(e) => onChange(e.target.value as 'admin' | 'manager' | 'employee' | 'customer')}
      disabled={disabled}
      className="rounded-lg py-2 px-3 pr-7 text-[0.8125rem]"
      style={{
        border: '1px solid var(--border)',
        backgroundColor: 'var(--background)',
        color: 'var(--foreground)',
        appearance: 'none',
      }}
    >
      <option value="admin">{t('users.roles.admin')}</option>
      <option value="manager">{t('users.roles.manager')}</option>
      <option value="employee">{t('users.roles.employee')}</option>
      <option value="customer">{t('users.roles.customer')}</option>
    </select>
  );
}
